// extracted by mini-css-extract-plugin
export var box = "_9o-1";
export var checked = "_9o-2";
export var descriptionSpacer = "_9o-9";
export var disabled = "_9o-3";
export var icon = "_9o-6";
export var input = "_9o-0";
export var labelSpacer = "_9o-8";
export var medium = "_9o-5";
export var small = "_9o-4";
export var text = "_9o-7";